import React , {useEffect, useState} from 'react'
import {Link, NavLink, useNavigate} from 'react-router-dom'
import {Button} from 'react-bootstrap';
import {Offcanvas} from 'react-bootstrap';




 

const mainLinks=[{text:'TOne Home',link:'https://www.teluguone.com'},
                     {text:'News',link:'https://www.teluguone.com/news'},
                     {text:'Movie News',link:'https://www.teluguone.com/tmdb'},
                     {text:'Movies',link:'https://www.teluguone.com/movies'},
                     {text:'Photos',link:'https://www.teluguone.com/photos'},
                     {text:'Grandalayam',link:'https://www.teluguone.com/grandalayam'},
                      {text:'Shortfilms',link:'https://www.teluguone.com/shortfilms'},
                      {text:'Videos',link:'https://www.teluguone.com/videos'},
                      // {text:'KidsOne',link:'https://www.kidsone.in'},
                       {text:'TORi(Radio)',link:'https://www.teluguoneradio.com'},
                       {text:'Recipes',link:'https://www.teluguone.com/recipes'},
                    //  {text:'Vanitha',link:'https://www.teluguone.com/vanitha'},
                    //   {text:'Sahityam',link:'https://www.teluguone.com/sahityam'},
                    //  {text:"Astrology",link:"https://www.teluguone.com/toneastrology"},
                    //  {text:"Comedy",link:"https://www.teluguone.com/comedy"},
                    //  {text:"Nri",link:"https://www.teluguone.com/nri"},
                    //  {text:'Greetings',link:'https://www.teluguone.com/tonegreetings'},
                    //   {text:'Health',link:'https://www.teluguone.com/health'},                   
                    // {text:"Charity",link:"https://www.teluguonefoundation.in/index.html"}                     
            ]

const mobileMenuLinks=[{ text: 'TOne Home', link: 'https://www.teluguone.com' },{text:"News",link:"https://www.teluguone.com/news"},{text:"Movie News",link:"https://www.teluguone.com/tmdb"},
  {text:"Movies",link:"https://www.teluguone.com/movies"},{text:"Photos",link:"https://www.teluguone.com/photos"},
  {text:"Grandalayam",link:"https://www.teluguone.com/grandalayam"},{text:"Shortfilms",link:"https://www.teluguone.com/shortfilms"},
  {text:"Bakthi",link:"https://www.teluguone.com/devotional"},{text:"Videos",link:"https://www.teluguone.com/videos"},{text:"Recipes",link:"https://www.teluguone.com/recipes"},
  {text:"Comedy",link:"https://www.teluguone.com/comedy"},{text:"Vanitha",link:"https://www.teluguone.com/vanitha"}]



const pageLinks=[{text:"Home",link:"/"},{text:"Stotralu",link:"/contents/stotralu-943.html"},{text:"Sahasranamalu",link:"/contents/sahasranamalu-937.html"},
    {text:"Mangalaharathulu ",link:"/videolist/mangalaharathulu-40.html"},{text:"Vratalu",link:"/subpages/vratalu-113.html"},{text:"Deity",link:"/contents/gods-47.html"},
    {text:"Festivals",link:"/contents/festivals-50.html"},{text:"Temples",link:"/subpages/punyakshetralu-65.html"},{text:"Audio",link:"/contents/audio-49.html"},
    {text:"Video",link:"/videos/bhaktivideos.html"},{text:"Archives",link:"/contents/library-48.html"},
]





const DevotionalHeader = () => {
 
 
           const [adJson ,setAdJson] = useState(null)
          const navigate = useNavigate()
 
   useEffect(() => {
   fetch("https://www.teluguone.com/teluguone-ssr-server/ad.php")
    .then(res => res.json())
    .then(data => setAdJson(data))
    .catch(err => console.error(err));
  }, []);
 
 
 
  return (
    <div className='devotional-header container-fluid'>
         
     <div className='row'>
           <div className='col-12 devotional-header-main-links-container'>
              
              <nav>
                   {mainLinks.map((item,index) => <a key={index} href={item.link} target='_blank' rel='noreferrer' >{item.text}</a> )}
                   <div className="it-is-more">More▾<div className="more-list">
                             <a href="https://teluguone.com/vanitha/" target='_blank' rel='noreferrer' >Vanitha</a>
                             <a href="https://teluguone.com/toneastrology/" target='_blank' rel='noreferrer'>Astrology</a>
                             <a href="https://teluguone.com/comedy/"  target='_blank' rel='noreferrer' >Comedy</a>
                             <a href="https://www.teluguone.com/nri/index.html" target='_blank' rel='noreferrer' >Nri Corner</a>
                             <a href="https://www.teluguone.com/tonegreetings/index.html" target='_blank' rel='noreferrer' >Greetings</a>
                             <a href="https://teluguone.com/health/index.html" target='_blank' rel='noreferrer' >Health</a>
                             <a href="https://www.teluguone.com/sahityam/" target='_blank' rel='noreferrer' >Sahityam</a>
                             <a href="https://www.kidsone.in/" target='_blank' rel='noreferrer' >Kids</a>
                             <a href="https://www.teluguonefoundation.in/index.html" target='_blank' rel='noreferrer' >Charity</a>
                   </div></div>
              </nav>
        
           </div>
           <DevotionalMobileHeader />
          <div className='col-3 col-sm-2 devotional-header-logo-container'>
              <img  src="/devotional/assets/images/devotional.png" alt="devotional-header-logo" onClick={() => navigate('/')} />
          </div>
           <div className="col-sm-10 col-8 devotional-banners-container">
                        <a href="https://www.youtube.com/watch?v=RLnUgn4uKKA" target="_blank">
                          <img src="/devotional/assets/images/tone_fashion.webp" alt="g-h-banner" className="devotional-header-banner" draggable="false" />
                        </a>
                        <a href="https://www.youtube.com/c/HealthOne/videos" target="_blank">
                         <img src="/devotional/assets/images/tone_health.webp" alt="g-h-banner" className="devotional-header-banner" draggable="false" />
                        </a>
                         {adJson &&  <a href={adJson.adLink} target='_blank' style={{textDecoration:"none"}} className='mobile'>
                           <img  src={adJson.adImg} alt="g-h-banner" className='devotional-header-banner  adByJson' />
                        </a>
                        }
                 </div>
        
          <div className='col-12 devotional-header-page-links-container'>
                <nav>
                     {pageLinks.map((item,index) => <NavLink className={({ isActive }) =>   isActive ? "active-page-link" : "" } key={index} to={item.link} >{item.text}</NavLink> )}
                </nav>
          </div>
     </div>

    </div>
  )
}

export default DevotionalHeader;


function  DevotionalMobileHeader() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='devotional-mobile-header'>
      <Button  variant="primary" onClick={handleShow}>
      <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><path stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M4 7h22M4 15h22M4 23h22"></path></svg>
      </Button>

      <Offcanvas className="devotional-mobile-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
        <img  loading="lazy" src={`/devotional/assets/images/tone_logo.webp`}
                        alt="tone-logo" className="header-logo"/>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <nav className="devotional-mobile-header-menu">
                {mobileMenuLinks.map((item,index) => <Link className='devotional-mobile-menu-link' rel="noopener noreferrer"  key={index} to={item.link}>{item.text}</Link>)}
             
            </nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
